(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2755,1993],{

/***/ 41993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DotIndicatorComponent": function() { return /* binding */ DotIndicatorComponent; },
/* harmony export */   "default": function() { return /* binding */ CarouselIndicator; },
/* harmony export */   "useGetChevronComponent": function() { return /* binding */ useGetChevronComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69466);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_components_DesignSystem_ModernTheme_utils_common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20901);
/* harmony import */ var _ListPresentation_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24200);
/* harmony import */ var _ListPresentation_hooks_useGetElementRects__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18554);












var GAP = 36;
function CarouselIndicator(param) {
    var _config = param.config, config = _config === void 0 ? {} : _config, _isVisible = param.isVisible, isVisible = _isVisible === void 0 ? false : _isVisible, carouselIndicatorConfigs = param.carouselIndicatorConfigs, onNextArrowClick = param.onNextArrowClick, onPrevArrowClick = param.onPrevArrowClick, itemContainerLayoutChange = param.itemContainerLayoutChange, arrowPosition = param.arrowPosition, showArrowUI = param.showArrowUI, isMobile = param.isMobile, containerHorizontalPadding = param.containerHorizontalPadding;
    var _RenderSlider = function _RenderSlider() {
        switch(progressIndicator){
            case "fullWidthBar":
                {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliderComponent, {
                        width: "100%",
                        scrollPercentage: scrollPercentage,
                        progressIndicatorColor: progressIndicatorColor
                    });
                }
            case "shortProgressBar":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliderComponent, {
                    height: "5px",
                    width: "132px",
                    scrollPercentage: scrollPercentage,
                    progressIndicatorColor: progressIndicatorColor
                });
            case "dashAndDots":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DotIndicatorComponent, {
                    overflowSectionCount: overflowSectionCount,
                    currentFocusedSectionItem: Math.round(currentFocusedSectionExact),
                    progressIndicatorColor: progressIndicatorColor,
                    direction: direction
                });
            default:
                return null;
        }
    };
    var _RenderArrows = function _RenderArrows() {
        var ref, ref1;
        var showArrow = showArrowUI && !arrowPositionKT.isTop;
        var arrowVerticalPositionOffset = ((ref = layoutWrapperLayoutChange.elementRect) === null || ref === void 0 ? void 0 : ref.clientHeight) + (!Slider ? -GAP : 0) + (itemContainerLayoutChange === null || itemContainerLayoutChange === void 0 ? void 0 : (ref1 = itemContainerLayoutChange.elementRect) === null || ref1 === void 0 ? void 0 : ref1.clientHeight) / 2;
        return {
            LeftArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeftArrow, {
                isVisible: showArrow,
                className: arrowPositionKT.isCenter ? "tw-absolute tw-left-[-20px] tw-z-10 tw-translate-y-[-50%]" : "",
                style: {
                    bottom: arrowVerticalPositionOffset
                }
            }),
            RightArrow: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightArrow, {
                isVisible: showArrow,
                className: arrowPositionKT.isCenter ? "tw-absolute tw-right-[-20px] tw-z-10 tw-translate-y-[-50%]" : "",
                style: {
                    bottom: arrowVerticalPositionOffset
                }
            })
        };
    };
    var ref = carouselIndicatorConfigs || {}, direction = ref.direction, _scrollPercentage = ref.scrollPercentage, scrollPercentage = _scrollPercentage === void 0 ? 0 : _scrollPercentage, _overflowSectionCount = ref.overflowSectionCount, overflowSectionCount = _overflowSectionCount === void 0 ? 0 : _overflowSectionCount, _currentFocusedSectionExact = ref.currentFocusedSectionExact, currentFocusedSectionExact = _currentFocusedSectionExact === void 0 ? 0 : _currentFocusedSectionExact;
    var ref1 = config || {}, progressIndicator = ref1.progressIndicator, arrowShape = ref1.arrowShape, _progressIndicatorColor = ref1.progressIndicatorColor, progressIndicatorColor = _progressIndicatorColor === void 0 ? "#111C36" : _progressIndicatorColor;
    var layoutWrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_ListPresentation_hooks_useGetElementRects__WEBPACK_IMPORTED_MODULE_7__/* .useGetElementRects */ .w)({
        elementRef: layoutWrapperRef
    }), 1), layoutWrapperLayoutChange = ref2[0];
    var ref3 = useGetChevronComponent({
        type: arrowShape,
        onNextArrowClick: onNextArrowClick,
        onPrevArrowClick: onPrevArrowClick,
        scrollPercentage: scrollPercentage,
        isMobile: isMobile,
        colorConfig: {
            arrowColor: config.arrowColor,
            shapeColor: config.shapeColor
        }
    }), LeftArrow = ref3.LeftArrow, RightArrow = ref3.RightArrow;
    if (!isVisible) {
        return null;
    }
    var arrowPositionKT = {
        isTop: !isMobile ? arrowPosition === "top" : false,
        isCenter: !isMobile ? arrowPosition === "center" : false,
        isBottom: !isMobile ? arrowPosition === "bottom" : true
    };
    var Slider = _RenderSlider();
    var GAP_APPLIED = Slider || arrowPositionKT.isBottom ? 36 : 0;
    var Arrows = _RenderArrows();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: layoutWrapperRef,
        className: "tw-relative tw-mx-auto tw-flex tw-w-[100%] tw-select-none tw-items-center tw-justify-center tw-gap-[20px]",
        style: {
            marginTop: "".concat(GAP_APPLIED, "px"),
            padding: "0px ".concat(containerHorizontalPadding, "px")
        },
        children: [
            Arrows.LeftArrow,
            Slider,
            Arrows.RightArrow
        ]
    });
}
function SliderComponent(param) {
    var _height = param.height, height = _height === void 0 ? "2px" : _height, width = param.width, scrollPercentage = param.scrollPercentage, progressIndicatorColor = param.progressIndicatorColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "tw-relative tw-rounded-[6px] tw-bg-[#111C361F]",
        style: {
            width: width,
            height: height,
            transform: "translateY(".concat(-height / 2, ")")
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "tw-absolute tw-h-[100%] tw-rounded-[6px] tw-transition-all",
            style: {
                width: "".concat(scrollPercentage, "%"),
                background: progressIndicatorColor
            }
        })
    });
}
var CONTAINER_WIDTH = 120;
function DotIndicatorComponent(param) {
    var _overflowSectionCount = param.overflowSectionCount, overflowSectionCount = _overflowSectionCount === void 0 ? 0 : _overflowSectionCount, currentFocusedSectionItem = param.currentFocusedSectionItem, progressIndicatorColor = param.progressIndicatorColor, direction = param.direction, _containerWidth = param.containerWidth, containerWidth = _containerWidth === void 0 ? CONTAINER_WIDTH : _containerWidth, _styles = param.styles, styles = _styles === void 0 ? {} : _styles, _dimensions = param.dimensions, dimensions = _dimensions === void 0 ? {
        width: "tw-w-[5px]",
        widthOfSelected: "tw-w-[30px]",
        height: "tw-h-[5px]"
    } : _dimensions;
    var dotsContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var dotsRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref;
        var selectedIndex = currentFocusedSectionItem - 1;
        var selectedDotElement = (ref = dotsRef.current) === null || ref === void 0 ? void 0 : ref[selectedIndex];
        if (dotsContainerRef.current) {
            var ref1, ref2;
            dotsContainerRef.current.scrollTo({
                left: ((ref1 = dotsContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollLeft) + (selectedDotElement === null || selectedDotElement === void 0 ? void 0 : selectedDotElement.getBoundingClientRect().left) - ((ref2 = dotsContainerRef.current) === null || ref2 === void 0 ? void 0 : ref2.getBoundingClientRect().left) + (direction === "to-right" ? -70 : -45),
                top: 0
            });
        }
    }, [
        currentFocusedSectionItem,
        overflowSectionCount,
        direction
    ]);
    if (!overflowSectionCount) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            width: "".concat(containerWidth, "px")
        }, styles),
        className: "tw-flex tw-justify-center tw-gap-[6px]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            ref: dotsContainerRef,
            className: "no-scrollbar tw-flex tw-items-center tw-gap-[6px] tw-overflow-x-auto",
            children: Array.from(Array(overflowSectionCount).keys()).map(function(_, index) {
                var isSelected = currentFocusedSectionItem === index + 1;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: function(node) {
                        return dotsRef.current[index] = node;
                    },
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("tw-h-[5px] tw-shrink-0 tw-rounded-[3px]  tw-transition-all", dimensions.height, !isSelected ? dimensions.width : dimensions.widthOfSelected || dimensions.width, !isSelected && "tw-bg-[#111C36]/[0.25]"),
                    style: isSelected ? {
                        background: progressIndicatorColor
                    } : {}
                }, index);
            })
        })
    });
}
function useGetChevronComponent(param) {
    var type = param.type, onNextArrowClick = param.onNextArrowClick, onPrevArrowClick = param.onPrevArrowClick, scrollPercentage = param.scrollPercentage, isMobile = param.isMobile, colorConfig = param.colorConfig, _dimensions = param.dimensions, dimensions = _dimensions === void 0 ? {
        width: {
            mobile: "28px",
            desktop: "36px"
        },
        height: {
            mobile: "28px",
            desktop: "36px"
        }
    } : _dimensions;
    var styles = function() {
        var styles = {
            border: "",
            borderRadius: "0",
            background: (colorConfig === null || colorConfig === void 0 ? void 0 : colorConfig.shapeColor) || ""
        };
        switch(type){
            case "circular":
                styles.border = "0.75px solid #111C361F";
                styles.borderRadius = "20";
                break;
            case "rounded":
                styles.border = "0.75px solid #111C361F";
                styles.borderRadius = "5";
                break;
            case "square":
                styles.border = "0.75px solid #111C361F";
                break;
            default:
                styles.background = "";
                break;
        }
        return styles;
    }();
    var removeBorder = type === "onlyArrow";
    var iconProps = {
        width: dimensions.width[isMobile ? "mobile" : "desktop"],
        height: dimensions.height[isMobile ? "mobile" : "desktop"],
        removeBorder: removeBorder,
        bgColor: styles.background,
        borderRadius: styles.borderRadius
    };
    return {
        LeftArrow: function(_param) {
            var _isVisible = _param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
                "isVisible"
            ]);
            return isVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(// isMobile ? 'tw-h-[28px]' : 'tw-h-[36px]',
                "tw-pointer-events-auto", scrollPercentage ? "tw-cursor-pointer" : " ", props.className),
                style: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.merge)(props.style, {
                    width: dimensions.width[isMobile ? "mobile" : "desktop"],
                    height: dimensions.height[isMobile ? "mobile" : "desktop"]
                }, !removeBorder ? {
                    boxShadow: "0px 0px 1.5px 0px #111C3633",
                    borderRadius: styles.borderRadius + "px"
                } : {}),
                onClick: onPrevArrowClick,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .RightArrowIcon */ .A, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                    className: "tw-rotate-180"
                }, iconProps), {
                    arrowColor: scrollPercentage <= _ListPresentation_utils__WEBPACK_IMPORTED_MODULE_6__/* .INITIAL_SCROLL_PERCENTAGE */ .Sk ? (0,src_components_DesignSystem_ModernTheme_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .hexToRgba */ .a7)(colorConfig.arrowColor, 0.5) : colorConfig.arrowColor
                }))
            }));
        },
        RightArrow: function(_param) {
            var _isVisible = _param.isVisible, isVisible = _isVisible === void 0 ? true : _isVisible, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_param, [
                "isVisible"
            ]);
            return isVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("tw-pointer-events-auto", // isMobile ? 'tw-h-[28px]' : 'tw-h-[36px]',
                scrollPercentage >= 100 ? "" : "tw-cursor-pointer ", props.className),
                style: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.merge)(props.style, props.style, {
                    width: dimensions.width[isMobile ? "mobile" : "desktop"],
                    height: dimensions.height[isMobile ? "mobile" : "desktop"]
                }, !removeBorder ? {
                    boxShadow: "0px 0px 1.5px 0px #111C3633",
                    borderRadius: styles.borderRadius + "px"
                } : {}),
                onClick: onNextArrowClick,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .RightArrowIcon */ .A, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, iconProps), {
                    arrowColor: scrollPercentage >= 100 ? (0,src_components_DesignSystem_ModernTheme_utils_common__WEBPACK_IMPORTED_MODULE_5__/* .hexToRgba */ .a7)(colorConfig.arrowColor, 0.5) : colorConfig.arrowColor
                }))
            }));
        }
    };
}


/***/ }),

/***/ 69466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ RightArrowIcon; },
/* harmony export */   "G": function() { return /* binding */ DownArrowIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);




function RightArrowIcon(_param) {
    var _arrowColor = _param.arrowColor, arrowColor = _arrowColor === void 0 ? "#000" : _arrowColor, _bgColor = _param.bgColor, bgColor = _bgColor === void 0 ? "#fff" : _bgColor, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? "5" : _borderRadius, _removeBorder = _param.removeBorder, removeBorder = _removeBorder === void 0 ? false : _removeBorder, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "arrowColor",
        "bgColor",
        "borderRadius",
        "removeBorder"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "24",
                height: "24",
                fill: bgColor,
                rx: borderRadius,
                transform: "matrix(-1 0 0 1 24 0)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "23.25",
                height: "23.25",
                x: "-0.375",
                y: "0.375",
                stroke: arrowColor,
                strokeOpacity: "0.12",
                strokeWidth: !removeBorder ? "0.75" : "0",
                rx: borderRadius,
                transform: "matrix(-1 0 0 1 23.25 0)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                clipPath: "url(#clip0_304_3140)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    stroke: arrowColor,
                    strokeWidth: "1.5",
                    d: "M10.39 7.885l3.88 3.88-3.88 3.878"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_304_3140",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H13.714V13.714H0z",
                        transform: "matrix(0 1 1 0 5.14 5.143)"
                    })
                })
            })
        ]
    }));
}
function DownArrowIcon(_param) {
    var _arrowColor = _param.arrowColor, arrowColor = _arrowColor === void 0 ? "#fff" : _arrowColor, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "arrowColor"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "none",
        viewBox: "0 0 16 16"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("mask", {
                        id: "mask0_666_6105",
                        style: {
                            maskType: "alpha"
                        },
                        width: "16",
                        height: "10",
                        x: "0",
                        y: "3",
                        maskUnits: "userSpaceOnUse",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            fill: "#D9D9D9",
                            d: "M0 3H16V13H0z"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                        mask: "url(#mask0_666_6105)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            stroke: arrowColor,
                            strokeWidth: "1.6",
                            d: "M2.343 5.657L8 11.314l5.657-5.657"
                        })
                    })
                ]
            })
        })
    }));
}


/***/ }),

/***/ 32755:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ProductCard": function() { return /* reexport */ ProductCard; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/utils.tsx + 1 modules
var utils = __webpack_require__(81241);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss
var ContentAnimationStyles_module = __webpack_require__(89429);
var ContentAnimationStyles_module_default = /*#__PURE__*/__webpack_require__.n(ContentAnimationStyles_module);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/styles.module.scss
var styles_module = __webpack_require__(46482);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CardFrameCollection/components/CarouselIndicator.tsx
var CarouselIndicator = __webpack_require__(41993);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts + 6 modules
var WidgetDndContext = __webpack_require__(17502);
// EXTERNAL MODULE: ./src/hooks/useGetDeviceType.tsx
var useGetDeviceType = __webpack_require__(62946);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ListPresentation/utils.ts
var ListPresentation_utils = __webpack_require__(24200);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/CardFrameCollection/utils.ts
var CardFrameCollection_utils = __webpack_require__(90331);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 169 modules
var motion = __webpack_require__(37563);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/components/ImageRenderer.tsx















function ImageRenderer(param) {
    var images = param.images, config = param.config, removeGlobalStyle = param.removeGlobalStyle, productData = param.productData, isButtonInOverlay = param.isButtonInOverlay;
    var renderIncrementalImage = function renderIncrementalImage(currentScrolledImageIndex) {
        var initialImagesLength = initialImagesToRender === null || initialImagesToRender === void 0 ? void 0 : initialImagesToRender.length;
        if (initialImagesLength === 1) return;
        if (currentScrolledImageIndex % initialImagesLength === initialImagesLength - 1) {
            var nextImageToPick = currentScrolledImageIndex % initialImagesLength + 1 >= initialImagesLength ? 0 : currentScrolledImageIndex % initialImagesLength + 1;
            setImagesToRender(function(data) {
                return currentScrolledImageIndex % initialImagesLength === initialImagesLength - 1 ? (0,_to_consumable_array/* default */.Z)(data).concat((0,_to_consumable_array/* default */.Z)(initialImagesToRender.slice(nextImageToPick, nextImageToPick + 4 >= initialImagesLength ? initialImagesLength : nextImageToPick + 1))) : data;
            });
        }
    };
    var pauseSlideShow = function pauseSlideShow() {
        slideShowRef.current && clearInterval(slideShowRef.current);
    };
    var onSlideShowOver = function onSlideShowOver() {
        resetSlideShow();
    };
    var resetSlideShow = function resetSlideShow() {
        var ref;
        slideShowRef.current && clearInterval(slideShowRef.current);
        setImagesToRender(initialImagesToRender);
        (ref = imagesContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollTo({
            left: 0,
            top: 0,
            behavior: "instant"
        });
    };
    var getImage = function getImage() {
        var hoverType = config === null || config === void 0 ? void 0 : config.hoverType;
        // if (isMobile || (config?.imageType !== 'single' && imagesToRender?.length < 2)) {
        //   hoverType = 'zoomIn';
        // }
        switch(hoverType){
            case "zoomIn":
            case "ambient":
            case "none":
                return imagesToRender === null || imagesToRender === void 0 ? void 0 : imagesToRender.map(function(imageData) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: imageData.alt_text,
                        loading: isBuilder ? "eager" : "lazy",
                        className: classnames_default()("tw-h-full tw-w-full tw-flex-shrink-0 tw-object-cover", "[&:hover]:tw-shadow-[0px_2px_2px_0px_#00000040]", removeGlobalStyle, !isMobile && (ContentAnimationStyles_module_default())[(0,CardFrameCollection_utils/* getCurrentClass */.WR)(hoverType)]),
                        src: imageData === null || imageData === void 0 ? void 0 : imageData.image_url
                    }, imageData === null || imageData === void 0 ? void 0 : imageData.image_url);
                });
            case "nextImage":
                var variants = {
                    hidden: {
                        opacity: 0
                    },
                    visible: {
                        opacity: 1
                    }
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("tw-relative tw-h-full tw-w-full tw-flex-shrink-0  tw-select-none", "[&:hover]:tw-shadow-[0px_2px_2px_0px_#00000040]"),
                    onMouseEnter: function() {
                        return setImageContainerConfigs({
                            isHovered: true,
                            type: "nextImage"
                        });
                    },
                    onMouseLeave: function() {
                        return setImageContainerConfigs({
                            isHovered: false,
                            type: ""
                        });
                    },
                    children: (imagesToRender === null || imagesToRender === void 0 ? void 0 : imagesToRender.length) > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        children: imagesToRender === null || imagesToRender === void 0 ? void 0 : imagesToRender.map(function(imageData, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.img */.E.img, {
                                alt: imageData.alt_text,
                                initial: !isMobile && imagesToRender.length > 1 && index === 0 && !imageContainerConfigs.isHovered ? "visible" : "hidden",
                                animate: index === 0 && imageContainerConfigs.isHovered ? "hidden" : "visible",
                                exit: index === 1 && !imageContainerConfigs.isHovered ? "hidden" : "visible",
                                variants: variants,
                                loading: isBuilder ? "eager" : "lazy",
                                className: classnames_default()("tw-absolute tw-h-full tw-w-full tw-object-cover tw-transition-all tw-ease-linear", "[&:hover]:tw-shadow-[0px_2px_2px_0px_#00000040]", removeGlobalStyle, index === 0 ? "tw-z-[1] tw-opacity-[1]" : "tw-z-[0] tw-opacity-[0]"),
                                src: imageData === null || imageData === void 0 ? void 0 : imageData.image_url
                            }, (imageData === null || imageData === void 0 ? void 0 : imageData.image_url) + index);
                        })
                    }) : imagesToRender === null || imagesToRender === void 0 ? void 0 : imagesToRender.map(function(imageData, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            alt: imageData.alt_text,
                            loading: isBuilder ? "eager" : "lazy",
                            className: classnames_default()("tw-absolute tw-h-full tw-w-full tw-object-cover tw-transition-all tw-ease-linear", "[&:hover]:tw-shadow-[0px_2px_2px_0px_#00000040]", removeGlobalStyle, !isMobile && (ContentAnimationStyles_module_default())[(0,CardFrameCollection_utils/* getCurrentClass */.WR)("zoomIn")]),
                            src: imageData === null || imageData === void 0 ? void 0 : imageData.image_url
                        }, (imageData === null || imageData === void 0 ? void 0 : imageData.image_url) + index);
                    })
                });
            case "runSlideshow":
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("tw-relative tw-h-full tw-w-full tw-select-none", "[&:hover]:tw-shadow-[0px_2px_2px_0px_#00000040]"),
                        onMouseEnter: function() {
                            return setImageContainerConfigs({
                                isHovered: true,
                                type: "runSlideshow"
                            });
                        },
                        onMouseLeave: function() {
                            onSlideShowOver();
                            setImageContainerConfigs({
                                isHovered: false,
                                type: ""
                            });
                        },
                        children: [
                            (imagesToRender === null || imagesToRender === void 0 ? void 0 : imagesToRender.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("tw-pointer-events-none tw-absolute tw-z-[4] tw-flex tw-h-full tw-w-full tw-items-center tw-justify-between tw-p-[10px]  tw-transition-opacity", removeGlobalStyle, !imageContainerConfigs.isHovered && !isMobile && "tw-pointer-events-none tw-opacity-0"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftArrow, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselIndicator.DotIndicatorComponent, {
                                        styles: !isButtonInOverlay ? {
                                            marginTop: "auto"
                                        } : {
                                            position: "absolute",
                                            bottom: "60px",
                                            left: "50%",
                                            transform: "translateX(-50%)"
                                        },
                                        overflowSectionCount: carouselIndicatorConfigs.overflowSectionCount,
                                        currentFocusedSectionItem: ((initialImagesToRender === null || initialImagesToRender === void 0 ? void 0 : initialImagesToRender.length) < carouselIndicatorConfigs.currentFocusedSectionItem ? carouselIndicatorConfigs.currentFocusedSectionItem : imagesToRender === null || imagesToRender === void 0 ? void 0 : imagesToRender.length) % (initialImagesToRender === null || initialImagesToRender === void 0 ? void 0 : initialImagesToRender.length) === 0 ? initialImagesToRender === null || initialImagesToRender === void 0 ? void 0 : initialImagesToRender.length : ((initialImagesToRender === null || initialImagesToRender === void 0 ? void 0 : initialImagesToRender.length) < carouselIndicatorConfigs.currentFocusedSectionItem ? carouselIndicatorConfigs.currentFocusedSectionItem : imagesToRender === null || imagesToRender === void 0 ? void 0 : imagesToRender.length) % (initialImagesToRender === null || initialImagesToRender === void 0 ? void 0 : initialImagesToRender.length),
                                        progressIndicatorColor: config === null || config === void 0 ? void 0 : config.activeDotColor,
                                        direction: carouselIndicatorConfigs.direction,
                                        containerWidth: 40,
                                        dimensions: {
                                            width: "tw-w-[4px]",
                                            widthOfSelected: "tw-w-[4px]",
                                            height: "tw-h-[4px]"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightArrow, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: imagesContainerRef,
                                className: "no-scrollbar tw-flex tw-h-full tw-w-full tw-touch-none tw-overflow-auto",
                                onScroll: function(e) {
                                    return (0,ListPresentation_utils/* onCarouselScroll */.ns)({
                                        e: e,
                                        setCarouselIndicatorConfigs: setCarouselIndicatorConfigs
                                    });
                                },
                                onMouseEnter: startSlideShow,
                                onMouseLeave: pauseSlideShow,
                                children: imagesToRender === null || imagesToRender === void 0 ? void 0 : imagesToRender.map(function(imageData, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: imageData.alt_text,
                                        loading: isBuilder ? "eager" : "lazy",
                                        className: classnames_default()("tw-h-full tw-w-full tw-flex-shrink-0 tw-object-cover", removeGlobalStyle),
                                        src: imageData === null || imageData === void 0 ? void 0 : imageData.image_url
                                    }, (imageData === null || imageData === void 0 ? void 0 : imageData.image_url) + index);
                                })
                            })
                        ]
                    });
                }
            case 4:
                {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onMouseOver: function() {
                            return setIsImageHovered(true);
                        },
                        onMouseLeave: function() {
                            return setIsImageHovered(false);
                        },
                        className: classnames_default()((styles_module_default())["scroll-container"], "tw-h-full tw-w-full"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()(isImageHovered && (styles_module_default())["carousel-primary"], "tw-h-full tw-w-full"),
                                children: imagesToRender === null || imagesToRender === void 0 ? void 0 : imagesToRender.map(function(imageData) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: imageData.alt_text,
                                        loading: isBuilder ? "eager" : "lazy",
                                        className: classnames_default()("tw-h-full tw-w-full tw-object-cover", removeGlobalStyle),
                                        src: imageData === null || imageData === void 0 ? void 0 : imageData.image_url
                                    }, imageData === null || imageData === void 0 ? void 0 : imageData.image_url);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()(isImageHovered && (styles_module_default())["carousel-primary"], isImageHovered && (styles_module_default())["carousel-secondary"], "tw-h-full tw-w-full"),
                                children: imagesToRender === null || imagesToRender === void 0 ? void 0 : imagesToRender.map(function(imageData) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        alt: imageData.alt_text,
                                        loading: isBuilder ? "eager" : "lazy",
                                        className: classnames_default()("tw-h-full tw-w-full tw-object-cover", removeGlobalStyle),
                                        src: imageData === null || imageData === void 0 ? void 0 : imageData.image_url
                                    }, imageData === null || imageData === void 0 ? void 0 : imageData.image_url);
                                })
                            })
                        ]
                    });
                }
            default:
                return null;
        }
    };
    var // isNextImageAnimation &&
    //   !isNextImageAnimationFallback &&
    //   `[&:hover>*:nth-child(1)]:tw-opacity-[0] [&:hover>*:nth-child(2)]:tw-opacity-[1]`, // [&>*]:tw-duration-[800ms] [&>*:nth-child(2)]:tw-delay-[700ms]
    ref;
    var ref1 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref1.widgetContextState, previewDevice = _widgetContextState.previewDevice, isBuilder = _widgetContextState.isBuilder;
    var slideShowRef = (0,react.useRef)();
    var ref2 = (0,react.useState)({
        isHovered: false,
        type: ""
    }), imageContainerConfigs = ref2[0], setImageContainerConfigs = ref2[1];
    var ref3 = (0,react.useState)([]), initialImagesToRender = ref3[0], setInitialImagesRender = ref3[1];
    var ref4 = (0,react.useState)([]), imagesToRender = ref4[0], setImagesToRender = ref4[1];
    var isNextImageAnimationFallback = (config === null || config === void 0 ? void 0 : config.hoverType) === "nextImage" && (imagesToRender === null || imagesToRender === void 0 ? void 0 : imagesToRender.length) < 2;
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = isBuilder ? previewDevice === "mobile" : deviceType === "mobile";
    var imagesContainerRef = (0,react.useRef)(null);
    var ref5 = (0,react.useState)(false), isImageHovered = ref5[0], setIsImageHovered = ref5[1];
    var ref6 = (0,react.useState)({
        scrollPercentage: 0,
        overflowSectionCount: imagesToRender === null || imagesToRender === void 0 ? void 0 : imagesToRender.length,
        currentFocusedSectionItem: 1,
        direction: "to-right"
    }), carouselIndicatorConfigs = ref6[0], setCarouselIndicatorConfigs = ref6[1];
    (0,react.useEffect)(function() {
        var imagesToRender = (0,utils/* getImagesToRender */.Ot)(config, images);
        setImagesToRender(images);
        setCarouselIndicatorConfigs(function(data) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                overflowSectionCount: imagesToRender === null || imagesToRender === void 0 ? void 0 : imagesToRender.length
            });
        });
        setInitialImagesRender(imagesToRender);
    }, [
        images,
        config === null || config === void 0 ? void 0 : config.imageType
    ]);
    (0,react.useEffect)(function() {
        if (!imageContainerConfigs.isHovered && imageContainerConfigs.type === "runSlideshow") {
            resetSlideShow();
        }
    }, [
        imageContainerConfigs.isHovered
    ]);
    // if (productData?.name === 'Trio showpiece') {
    //   console.log(
    //     'carouselIndicatorConfigs ',
    //     productData?.name + ':  ',
    //     carouselIndicatorConfigs
    //   );
    // }
    (0,react.useEffect)(function() {
        if (imageContainerConfigs.type === "runSlideshow") renderIncrementalImage(carouselIndicatorConfigs.currentFocusedSectionItem - 1);
    }, [
        carouselIndicatorConfigs.scrollPercentage,
        initialImagesToRender,
        imageContainerConfigs.type, 
    ]);
    var ref7 = (0,CarouselIndicator.useGetChevronComponent)({
        type: (config === null || config === void 0 ? void 0 : config.arrowShape) || "circular",
        onNextArrowClick: function(e) {
            var ref, ref1;
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            (ref = imagesContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollBy({
                left: (ref1 = imagesContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientWidth
            });
        },
        onPrevArrowClick: function(e) {
            var ref, ref1;
            e === null || e === void 0 ? void 0 : e.stopPropagation();
            (ref = imagesContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollBy({
                left: -1 * ((ref1 = imagesContainerRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientWidth)
            });
        },
        scrollPercentage: carouselIndicatorConfigs.scrollPercentage,
        isMobile: isMobile,
        colorConfig: {
            arrowColor: config === null || config === void 0 ? void 0 : config.arrowColor,
            shapeColor: "#fff"
        },
        dimensions: {
            width: {
                mobile: "12px",
                desktop: "24px"
            },
            height: {
                mobile: "12px",
                desktop: "24px"
            }
        }
    }), LeftArrow = ref7.LeftArrow, RightArrow = ref7.RightArrow;
    var startSlideShow = function() {
        if (imagesContainerRef.current) {
            slideShowRef.current = setInterval(function() {
                var ref;
                var ref1 = imagesContainerRef.current || {}, scrollLeft = ref1.scrollLeft, clientWidth = ref1.clientWidth;
                renderIncrementalImage(Math.ceil(scrollLeft / clientWidth));
                (ref = imagesContainerRef.current) === null || ref === void 0 ? void 0 : ref.scrollBy({
                    left: clientWidth
                });
            }, (config === null || config === void 0 ? void 0 : config.autoSlideTimer) * 1000);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("tw-h-full tw-w-full tw-overflow-hidden", removeGlobalStyle || "imgWrapperGlobalStyle"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()(removeGlobalStyle, "tw-relative tw-flex tw-h-full tw-w-full tw-select-none", (((ref = [
                "zoomIn",
                "ambient"
            ]) === null || ref === void 0 ? void 0 : ref.includes(config === null || config === void 0 ? void 0 : config.hoverType)) || isNextImageAnimationFallback) && "tw-overflow-hidden"),
            children: getImage()
        })
    });
}

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/config/paymentLinks.js
var paymentLinks = __webpack_require__(96668);
// EXTERNAL MODULE: ./src/components/DesignSystem/ModernTheme/utils/common.js + 9 modules
var common = __webpack_require__(20901);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Star.js
var Star = __webpack_require__(14957);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/muiStyles.ts
var muiStyles = __webpack_require__(88583);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/StarRounded.js
var StarRounded = __webpack_require__(38959);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.js
var useFeatureLocks = __webpack_require__(27560);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(68037);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/components/RatingComponent.tsx









function RatingComponent(param) {
    var productData = param.productData, _insertMarginBottom = param.insertMarginBottom, insertMarginBottom = _insertMarginBottom === void 0 ? false : _insertMarginBottom, type = param.type, _config = param.config, config = _config === void 0 ? {} : _config, _overrideStyles = param.overrideStyles, overrideStyles = _overrideStyles === void 0 ? {
        textColor: ""
    } : _overrideStyles;
    var _RenderMargin = function _RenderMargin() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: insertMarginBottom ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-mb-[12px]"
            }) : null
        });
    };
    var ref;
    var ratingData = productData === null || productData === void 0 ? void 0 : productData.store_item_review_rating;
    var reviewSettings = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.catalogReducer.reviewSettings;
    });
    var crrFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().crrFeatureStatus;
    var overrideTextColor = overrideStyles === null || overrideStyles === void 0 ? void 0 : overrideStyles.textColor;
    var hasRating = !(crrFeatureStatus === null || crrFeatureStatus === void 0 ? void 0 : crrFeatureStatus.isLocked) && (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && (ratingData === null || ratingData === void 0 ? void 0 : ratingData.review_rating) && ((ref = ratingData === null || ratingData === void 0 ? void 0 : ratingData.review_rating[0]) === null || ref === void 0 ? void 0 : ref.avg_rating);
    if (!hasRating || !(config === null || config === void 0 ? void 0 : config.showRatings)) {
        return _RenderMargin();
    }
    // const checkShowForAvgRating =
    //   config?.minAvgRating && ratingData?.review_rating[0]?.avg_rating >= 3.5;
    // const checkForAtleastMinNum =
    //   config?.minRating &&
    //   (ratingData?.review_rating[0]?.ratings_count || ratingData?.ratings_count) >= 3;
    // if (
    //   config?.ratingAppearance === 'avgRating' &&
    //   (!checkShowForAvgRating || !checkForAtleastMinNum)
    // ) {
    //   return null;
    // }
    var borderRadiusStyle = (0,utils/* getTagBorderRadius */.hQ)(config === null || config === void 0 ? void 0 : config.ratingShape);
    var Component = null;
    switch(config === null || config === void 0 ? void 0 : config.ratingAppearance){
        case "avgRating":
            var ref1, ref2;
            Component = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("tw-flex tw-w-max tw-items-center tw-gap-[2px] tw-px-[4px] tw-py-[3px]", borderRadiusStyle.className),
                style: {
                    border: "0.6px solid #D2D9E4",
                    background: config === null || config === void 0 ? void 0 : config.backgroundColor
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-flex tw-h-[10px] tw-items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Star/* default */.Z, {
                            sx: {
                                color: (config === null || config === void 0 ? void 0 : config.starColor) || "#219653",
                                fontSize: "12px"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "tw-m-0 tw-inline-flex tw-items-center tw-text-[11px] tw-font-semibold tw-leading-[1]",
                        style: {
                            color: config === null || config === void 0 ? void 0 : config.textColor
                        },
                        children: [
                            ratingData === null || ratingData === void 0 ? void 0 : (ref1 = ratingData.review_rating) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.avg_rating,
                            (config === null || config === void 0 ? void 0 : config.showReviewCount) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: classnames_default()("tw-font-semibold", (config === null || config === void 0 ? void 0 : config.reviewCountAppearance) === "bracket" && "tw-ml-[2px]"),
                                style: {
                                    color: config === null || config === void 0 ? void 0 : config.reviewCountColor
                                },
                                children: (config === null || config === void 0 ? void 0 : config.reviewCountAppearance) !== "bracket" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "tw-color-[#666666] tw-relative tw-top-[-0.529px] tw-mx-[4px] tw-text-[9px] tw-font-normal",
                                            children: "|"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: ratingData === null || ratingData === void 0 ? void 0 : ratingData.ratings_count
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        "(",
                                        ratingData === null || ratingData === void 0 ? void 0 : ratingData.ratings_count,
                                        ")"
                                    ]
                                })
                            }) : null
                        ]
                    })
                ]
            });
            break;
        case "fiveStar":
            var ref3, ref4;
            Component = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-relative tw-left-[-2.9px] tw-top-[-1.9px] tw-flex tw-items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "ratingReviewComponent tw-flex tw-h-[12px] tw-items-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(muiStyles/* ProductRating */.v, {
                            name: "customized-color",
                            value: ratingData === null || ratingData === void 0 ? void 0 : (ref3 = ratingData.review_rating) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : ref4.avg_rating,
                            sx: {
                                color: (config === null || config === void 0 ? void 0 : config.starColor) || "#FFC107"
                            },
                            precision: 0.1,
                            emptyIconColor: overrideTextColor && "rgba(255,255,255,0.6)",
                            readOnly: true,
                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRounded/* default */.Z, {
                                fontSize: "inherit"
                            }),
                            emptyIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarRounded/* default */.Z, {
                                fontSize: "inherit"
                            })
                        }),
                        (config === null || config === void 0 ? void 0 : config.showReviewCount) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classnames_default()("tw-relative tw-flex tw-items-center tw-text-[13px] tw-font-normal tw-leading-[1]", (config === null || config === void 0 ? void 0 : config.reviewCountAppearance) === "bracket" ? "tw-bottom-[-2px] tw-ml-[4px]" : "tw-bottom-[-1.497px]"),
                            style: {
                                color: overrideTextColor ? "rgba(255,255,255,0.7)" : config === null || config === void 0 ? void 0 : config.reviewCountColor
                            },
                            children: (config === null || config === void 0 ? void 0 : config.reviewCountAppearance) !== "bracket" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "tw-color-[#666666] tw-relative tw-mx-[4px] tw-text-[14px] tw-font-normal tw-leading-[1]",
                                        children: "|"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: ratingData === null || ratingData === void 0 ? void 0 : ratingData.ratings_count
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    "(",
                                    ratingData === null || ratingData === void 0 ? void 0 : ratingData.ratings_count,
                                    ")"
                                ]
                            })
                        }) : null
                    ]
                })
            });
            break;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            Component,
            _RenderMargin()
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(46976);
// EXTERNAL MODULE: ./src/containers/ProductDescription/Utils/common.js
var Utils_common = __webpack_require__(72911);
// EXTERNAL MODULE: ./src/hooks/useCartHandler.js
var useCartHandler = __webpack_require__(91240);
// EXTERNAL MODULE: ./src/assets/svgExports/MinusIcon.js
var MinusIcon = __webpack_require__(82513);
// EXTERNAL MODULE: ./src/assets/svgExports/PlusIcon.js
var PlusIcon = __webpack_require__(8886);
// EXTERNAL MODULE: ./src/utils/itemIndexFromCart.js
var itemIndexFromCart = __webpack_require__(48670);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/utils/itemQuantityValueComparison.js
var itemQuantityValueComparison = __webpack_require__(73175);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(67936);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var actions_common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(66162);
// EXTERNAL MODULE: ./src/utils/mutateItemObjectWithCartData.js
var mutateItemObjectWithCartData = __webpack_require__(22787);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/Carousel/utils.tsx
var Carousel_utils = __webpack_require__(58619);
// EXTERNAL MODULE: ./src/components/WidgetMaker/utils/buttonConstant.ts
var buttonConstant = __webpack_require__(91850);
// EXTERNAL MODULE: ./src/components/DesignSystem/AtomicDesignsUtilities/ContentButtonAnimationStyle.module.scss
var ContentButtonAnimationStyle_module = __webpack_require__(36508);
var ContentButtonAnimationStyle_module_default = /*#__PURE__*/__webpack_require__.n(ContentButtonAnimationStyle_module);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/components/AddToCartButton.tsx
/* eslint-disable no-unused-vars */ 






















function AddToCartButton(param) {
    var isMobile = param.isMobile, productData = param.productData, config = param.config, _isOverlay = param.isOverlay, isOverlay = _isOverlay === void 0 ? false : _isOverlay, snackbarMethods = param.snackbarMethods, _overrideStyles = param.overrideStyles, overrideStyles = _overrideStyles === void 0 ? {
        textColor: ""
    } : _overrideStyles;
    var openProductPersonalizationPopUp = // const wasItemAddedButThenItsVariantAdded =
    //   isItemInCart && itemQuantity && !productData?.available_quantity;
    /**
   * This function is responsible to perform 3 tasks:
   * 1. Set the active product data in personalisedProduct state of catalogReducer
   * 2. Set the product customization config ( image count, text count etc ) in personalisedProduct state of catalogReducer
   * 3. Open the product personalization popup
   */ function openProductPersonalizationPopUp() {
        handleSetProductData(productData);
        handleSetProductCustomizationCount(productData);
        onPersonalizeProductClick();
    };
    var _RenderIconComponent = function _RenderIconComponent(buttonData) {
        var ref;
        return IconComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: classnames_default()("tw-flex tw-cursor-pointer tw-items-center tw-justify-center", isMobile ? "tw-h-[16px] tw-w-[16px]" : "tw-h-[18px] tw-w-[18px]"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconComponent, {
                height: isMobile ? "16" : "18",
                width: isMobile ? "16" : "18",
                iconColor: (hoverColors === null || hoverColors === void 0 ? void 0 : hoverColors.text) || (buttonData === null || buttonData === void 0 ? void 0 : (ref = buttonData.btnStyleConfig) === null || ref === void 0 ? void 0 : ref.textColor)
            })
        });
    };
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            storeInfo: state.storeReducer.store,
            userData: state.userReducer,
            cartData: state.cartReducer
        };
    }), storeInfo = ref1.storeInfo, userData = ref1.userData, cartData = ref1.cartData;
    var ref2 = (0,react.useState)(null), hoverColors = ref2[0], setHoverColors = ref2[1];
    var ref3 = (0,useCartHandler/* useCartHandlers */.u)(), handleIncreamentClick = ref3.handleIncreamentClick, handleDecreamentClick = ref3.handleDecreamentClick, handleSetProductData = ref3.handleSetProductData, handleSetProductCustomizationCount = ref3.handleSetProductCustomizationCount, onPersonalizeProductClick = ref3.onPersonalizeProductClick;
    // In below the image case
    var disableWholeButton = !(productData === null || productData === void 0 ? void 0 : productData.available);
    var overrideTextColor = overrideStyles === null || overrideStyles === void 0 ? void 0 : overrideStyles.textColor;
    var button = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        return (ref1 = (ref = config.buttonConfig) === null || ref === void 0 ? void 0 : ref.filter(function(btn) {
            return btn.isShow;
        })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.map) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, function(btnData) {
            var buttonData = (0,lodash.cloneDeep)(btnData);
            var isBtnTextual = buttonData.type === buttonConstant/* BUTTON_TYPE.TEXTUAL */.JB.TEXTUAL;
            var isBtnOutline = buttonData.type === buttonConstant/* BUTTON_TYPE.OUTLINE */.JB.OUTLINE;
            if (overrideTextColor) {
                if (isBtnOutline) {
                    buttonData.btnStyleConfig.textColor = overrideTextColor;
                    buttonData.btnStyleConfig.backgroundColor = overrideTextColor;
                }
                if (isBtnTextual) buttonData.btnStyleConfig.textColor = overrideTextColor;
            }
            return buttonData;
        });
    }, [
        config.buttonConfig,
        overrideTextColor
    ]);
    if (!(productData === null || productData === void 0 ? void 0 : productData.available) && isOverlay) {
        return null;
    }
    var isProductPersonalizationAvailable = (0,Utils_common/* checkProductPersonalizationExist */.wj)(storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.services) === null || ref === void 0 ? void 0 : ref.store_type_flag, productData === null || productData === void 0 ? void 0 : productData.product_personalization);
    var itemIndexInCart = (0,itemIndexFromCart/* itemIndexFromCart */.R)(cartData, productData);
    var isItemInCart = itemIndexInCart >= 0;
    var itemInCart = cartData === null || cartData === void 0 ? void 0 : cartData.items[itemIndexInCart];
    var itemQuantity = itemInCart === null || itemInCart === void 0 ? void 0 : itemInCart.quantity;
    var isIconBasedCTA = [
        "icon",
        "iconFrontOfProductName"
    ].includes(config === null || config === void 0 ? void 0 : config.buttonType);
    var isFullWidthCTA = !isIconBasedCTA;
    var shouldWholeButtonClick = !isItemInCart || isIconBasedCTA;
    var IconComponent = (0,utils/* getCTAIcon */.Vp)(config, isIconBasedCTA);
    var hasVariant = (productData === null || productData === void 0 ? void 0 : productData.variants_count) > 0;
    var disableAddition = (0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(itemInCart);
    var textThicknessStyle = (0,utils/* getTextThickness */.qn)(config === null || config === void 0 ? void 0 : config.buttonTextThicness);
    var goToCart = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(cart) {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                // await saveAdditionalRemark(cart);
                router_default().push((0,routes.getRoute)(routes.PATH.CART, storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                return [
                    2
                ];
            });
        });
        return function goToCart(cart) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAddRemoveItem = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e, type) {
            var isNewAddition, //  if (disableWholeButton) {
            //    return;
            //  }
            ref, ref1, ref2, ref3, productItem, newState;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                isNewAddition = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                (ref = e.stopPropagation) === null || ref === void 0 ? void 0 : ref.call(e);
                (ref1 = e.preventDefault) === null || ref1 === void 0 ? void 0 : ref1.call(e);
                if (isNewAddition && isItemInCart) return [
                    2
                ];
                // if (type === BUTTON_ACTION.INCREMENT && disableAddition) return;
                dispatch((0,logs/* pushEventsLog */.U)({
                    event_name: "Cx_ATC",
                    data: {
                        store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                        domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref2 = storeInfo.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain,
                        page: window.location.href,
                        device: isMobile ? "Mobile" : "Desktop",
                        cx_number: userData === null || userData === void 0 ? void 0 : (ref3 = userData.data) === null || ref3 === void 0 ? void 0 : ref3.phone
                    }
                }));
                productItem = cartData.items[itemIndexInCart];
                // managed_inventory !== 0. available_quantity !== 0.
                // don't proceed to control flow if available_quantity is 0
                if (type === utils/* BUTTON_ACTION.INCREMENT */.MY.INCREMENT && (0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(itemInCart)) {
                    // toastNotifyInfo('No more units available of this item');
                    snackbarMethods === null || snackbarMethods === void 0 ? void 0 : snackbarMethods.openSnackbar({
                        message: "No more units available of this item",
                        vertical: "bottom",
                        horizontal: "center",
                        type: ""
                    });
                    return [
                        2
                    ];
                }
                snackbarMethods === null || snackbarMethods === void 0 ? void 0 : snackbarMethods.hideSnackbar();
                /** Check if variant present in this item */ if (hasVariant) {
                    dispatch((0,actions_common/* saveProductLoaderId */.XG)(productData === null || productData === void 0 ? void 0 : productData.id));
                    dispatch((0,catalog/* savePDPData */.zP)(productData));
                    /** check if item exist in cart */ if (itemIndexInCart !== -1) {
                        switch(type){
                            case utils/* BUTTON_ACTION.INCREMENT */.MY.INCREMENT:
                                dispatch((0,actions_common/* setVariantModalVisibility */.VZ)(true));
                                break;
                            case utils/* BUTTON_ACTION.DECREMENT */.MY.DECREMENT:
                                dispatch((0,actions_common/* setSelectedVariantModalVisibility */.rV)(true));
                                break;
                        }
                    } else {
                        /** get the details item for this item id */ dispatch((0,catalog/* fetchCatalogItemById */.eP)({
                            store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                            item_id: productData === null || productData === void 0 ? void 0 : productData.id,
                            src: "add_to_cart_button_in_product_card_widget_2.0"
                        }, true, function(data) {
                            handleSetProductData(data);
                        }));
                    }
                } else {
                    if (isProductPersonalizationAvailable && (productData === null || productData === void 0 ? void 0 : productData.product_personalization)) {
                        handleSetProductCustomizationCount(productData);
                        dispatch((0,catalog/* savePDPData */.zP)(productData));
                        handleSetProductData(productData);
                        switch(type){
                            case utils/* BUTTON_ACTION.ADD */.MY.ADD:
                                dispatch(openProductPersonalizationPopUp());
                                break;
                            case utils/* BUTTON_ACTION.INCREMENT */.MY.INCREMENT:
                                handleIncreamentClick(type, productData);
                                break;
                            case utils/* BUTTON_ACTION.DECREMENT */.MY.DECREMENT:
                                handleDecreamentClick(type, productData);
                                break;
                            default:
                                break;
                        }
                    } else {
                        newState = (0,mutateItemObjectWithCartData/* mutateItemObjectWithCartData */.L)(type, productData, cartData);
                        dispatch((0,cart/* saveCart */.FP)(newState));
                    }
                }
                return [
                    2
                ];
            });
        });
        return function handleAddRemoveItem(e, type) {
            return _ref.apply(this, arguments);
        };
    }();
    var addItemToCart = function(e) {
        if (shouldWholeButtonClick && !disableWholeButton) handleAddRemoveItem(e, !isItemInCart ? utils/* BUTTON_ACTION.ADD */.MY.ADD : utils/* BUTTON_ACTION.INCREMENT */.MY.INCREMENT, !isItemInCart);
    };
    return button === null || button === void 0 ? void 0 : button.map(function(buttonData, btnIndex) {
        var ref, ref1, ref2, ref3;
        // const overlayTextStyles: any = getOverlayTextStyles(cardFrameConfig, buttonData);
        var buttonVariant = (0,Carousel_utils/* getButtonVariantsData */.Tk)(buttonData, false);
        var selectedButtonType = buttonVariant[buttonData.type];
        var isBtnSolid = buttonData.type === buttonConstant/* BUTTON_TYPE.SOLID */.JB.SOLID;
        var isBtnTextual = buttonData.type === buttonConstant/* BUTTON_TYPE.TEXTUAL */.JB.TEXTUAL;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            disabled: disableWholeButton,
            btnType: buttonData.type,
            onClick: addItemToCart,
            buttonData: buttonData,
            color: isBtnTextual && overrideTextColor,
            selectedButtonData: selectedButtonType,
            variant: selectedButtonType.variant,
            disableHoverAnimation: isItemInCart || isMobile,
            useReversedColors: isItemInCart || isBtnSolid && !!overrideTextColor,
            className: classnames_default()("addToCtaButtonForProduct !tw-pointer-events-auto !tw-max-h-[44px] !tw-min-w-[auto] tw-cursor-pointer !tw-gap-[8.5px] !tw-font-medium", isFullWidthCTA && (isBtnTextual ? shouldWholeButtonClick ? "!tw-w-max" : "!tw-w-[81px]" : "!tw-w-full"), !isIconBasedCTA && !isBtnTextual && (isMobile ? "tw-py-[10px] !tw-text-[13px]" : "tw-py-[14px] !tw-text-[14px]"), isIconBasedCTA ? isMobile ? "!tw-p-[7px]" : "!tw-p-[9.5px]" : !isBtnTextual ? "!tw-px-[24px]" : "!tw-px-0 tw-py-0", isIconBasedCTA && (isMobile ? "!tw-h-[33px] !tw-w-[33px]" : "!tw-h-[36px] !tw-w-[36px]"), isIconBasedCTA ? "tw-cursor-pointer" : "tw-cursor-default", isOverlay && "!tw-shadow-[0px_2px_2px_0px_#00000040]", isIconBasedCTA && isMobile && !disableWholeButton && "!tw-border-none tw-shadow-[0px_2px_2px_0px_#00000040]", // isBtnSolid && !isIconBasedCTA ? ' !tw-border-none ' : '',
            // disable animations
            !(buttonData === null || buttonData === void 0 ? void 0 : (ref = buttonData.buttonAnimationConfig) === null || ref === void 0 ? void 0 : ref.classKey) || isIconBasedCTA ? "[&_p]:before:!tw-hidden" : !disableWholeButton && !isMobile && (ContentButtonAnimationStyle_module_default())[buttonData === null || buttonData === void 0 ? void 0 : (ref1 = buttonData.buttonAnimationConfig) === null || ref1 === void 0 ? void 0 : ref1.classKey], disableWholeButton && "!tw-opacity-50", !shouldWholeButtonClick && "[&_p]:before:!tw-hidden", isIconBasedCTA && isItemInCart && (!isMobile ? "!tw-w-[84px]" : "!tw-w-[70px]")),
            textWrapperClass: classnames_default()("!tw-w-full !tw-relative !tw-flex !tw-justify-center", isBtnTextual && "!tw-mb-[2.5px]", textThicknessStyle.className),
            getHoverColor: function(btnColors) {
                return setHoverColors(btnColors);
            },
            children: !isItemInCart ? !isIconBasedCTA ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "tw-inline-flex tw-w-[100%] tw-items-center tw-justify-center tw-gap-[8px]",
                children: [
                    _RenderIconComponent(buttonData),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: buttonData === null || buttonData === void 0 ? void 0 : buttonData.text
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()("tw-flex  tw-cursor-pointer tw-items-center tw-justify-center", isMobile ? "tw-h-[16px] tw-w-[16px]" : "tw-h-[18px] tw-w-[18px]"),
                children: !isItemInCart ? _RenderIconComponent(buttonData) : itemQuantity
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                className: "tw-inline-flex tw-w-[100%] tw-items-center tw-justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: function(e) {
                            return handleAddRemoveItem(e, utils/* BUTTON_ACTION.DECREMENT */.MY.DECREMENT);
                        },
                        className: classnames_default()("tw-flex tw-h-[100%] tw-cursor-pointer tw-items-center tw-justify-center", "tw-absolute tw-left-0 tw-top-1/2 -tw-translate-y-1/2"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MinusIcon/* MinusIcon */.V, {
                            iconHeight: 16,
                            iconWidth: 16,
                            iconColor: (hoverColors === null || hoverColors === void 0 ? void 0 : hoverColors.text) || (buttonData === null || buttonData === void 0 ? void 0 : (ref2 = buttonData.btnStyleConfig) === null || ref2 === void 0 ? void 0 : ref2.textColor)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: cartData.items[itemIndexInCart].quantity || 0
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        onClick: function(e) {
                            return handleAddRemoveItem(e, utils/* BUTTON_ACTION.INCREMENT */.MY.INCREMENT);
                        },
                        className: classnames_default()("tw-flex tw-h-[100%] tw-cursor-pointer tw-items-center tw-justify-center", "tw-absolute tw-right-0 tw-top-1/2 -tw-translate-y-1/2"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon/* PlusIcon */.p, {
                            iconHeight: 16,
                            iconWidth: 16,
                            iconColor: (hoverColors === null || hoverColors === void 0 ? void 0 : hoverColors.text) || (buttonData === null || buttonData === void 0 ? void 0 : (ref3 = buttonData.btnStyleConfig) === null || ref3 === void 0 ? void 0 : ref3.textColor),
                            style: {
                                opacity: !disableAddition ? 1 : 0.5
                            }
                        })
                    })
                ]
            })
        }, btnIndex);
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/components/OverlayItemsAligner.tsx






function OverlayItemsAligner(param) {
    var coordinates = param.coordinates, _isMobile = param.isMobile, isMobile = _isMobile === void 0 ? false : _isMobile, _children = param.children, children = _children === void 0 ? null : _children, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? {} : _customStyles, _customClass = param.customClass, customClass = _customClass === void 0 ? "" : _customClass, _config = param.config, config = _config === void 0 ? undefined : _config;
    var getHorizontalPosition = function getHorizontalPosition() {
        if ((config === null || config === void 0 ? void 0 : config.discountStyle) === "discountOverlay") {
            switch(config === null || config === void 0 ? void 0 : config.discountTag){
                case utils/* DISCOUNT_IMAGE_TAG.CIRCLE */.WL.CIRCLE:
                    return isMobile ? 4 : 6;
                case utils/* DISCOUNT_IMAGE_TAG.REVERSE_ARCH */.WL.REVERSE_ARCH:
                    return isMobile ? 6 : 8;
                case utils/* DISCOUNT_IMAGE_TAG.SQUARE */.WL.SQUARE:
                    return 0;
                default:
                    return isMobile ? 6 : 10;
            }
        }
        return isMobile ? 8 : 10;
    };
    var getVerticalPosition = function getVerticalPosition() {
        if ((config === null || config === void 0 ? void 0 : config.discountStyle) === "discountOverlay") {
            switch(config === null || config === void 0 ? void 0 : config.discountTag){
                case utils/* DISCOUNT_IMAGE_TAG.CIRCLE */.WL.CIRCLE:
                    return isMobile ? 4 : 6;
                case utils/* DISCOUNT_IMAGE_TAG.REVERSE_ARCH */.WL.REVERSE_ARCH:
                    return 0;
                case utils/* DISCOUNT_IMAGE_TAG.SQUARE */.WL.SQUARE:
                    return 0;
                default:
                    return isMobile ? 6 : 10;
            }
        }
        return isMobile ? 8 : 10;
    };
    var _obj;
    var style = (0,_object_spread/* default */.Z)((_obj = {}, (0,_define_property/* default */.Z)(_obj, coordinates.x, getHorizontalPosition()), (0,_define_property/* default */.Z)(_obj, coordinates.y, getVerticalPosition()), _obj), customStyles);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("tw-absolute tw-z-[1]", customClass),
        style: style,
        children: children
    });
}

// EXTERNAL MODULE: ./src/utils/getDiscountPercentage.js
var getDiscountPercentage = __webpack_require__(53716);
// EXTERNAL MODULE: ./src/utils/getStoreType.js
var getStoreType = __webpack_require__(66871);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/config/index.js
var src_config = __webpack_require__(77733);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/components/DiscountTag.tsx








function DiscountTag(param) {
    var config = param.config, productData = param.productData, isMobile = param.isMobile;
    var showPercentDiscount = (config === null || config === void 0 ? void 0 : config.discountType) === "percentage";
    var discount = showPercentDiscount ? (0,getDiscountPercentage/* getDiscountPercentage */.$)(productData === null || productData === void 0 ? void 0 : productData.price, productData === null || productData === void 0 ? void 0 : productData.discounted_price) : Math.floor((productData === null || productData === void 0 ? void 0 : productData.price) - (productData === null || productData === void 0 ? void 0 : productData.discounted_price));
    var isB2bStore = (0,getStoreType/* getStoreType */.K)() === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B;
    if (!discount || isB2bStore || !config) {
        return null;
    }
    switch(config === null || config === void 0 ? void 0 : config.discountStyle){
        case "discountOverlay":
            {
                var TagImageComponent = (0,utils/* getDiscountTagImageComponent */.lb)(config, isMobile);
                var isDiscountTypeRevArched = (config === null || config === void 0 ? void 0 : config.discountTag) === utils/* DISCOUNT_IMAGE_TAG.REVERSE_ARCH */.WL.REVERSE_ARCH;
                var isDiscountTypeSquare = (config === null || config === void 0 ? void 0 : config.discountTag) === utils/* DISCOUNT_IMAGE_TAG.SQUARE */.WL.SQUARE;
                var isDiscountTypeCircle = (config === null || config === void 0 ? void 0 : config.discountTag) === utils/* DISCOUNT_IMAGE_TAG.CIRCLE */.WL.CIRCLE;
                var translateOffset = function() {
                    if (isDiscountTypeRevArched) {
                        return isMobile ? 4 : 2.2;
                    }
                    if (isDiscountTypeSquare) {
                        return isMobile ? 1.5 : 1.95;
                    }
                    if (isDiscountTypeCircle) {
                        return isMobile ? 1.2 : 1.8;
                    }
                    return 0;
                }();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-relative",
                    style: {
                        transformOrigin: "top right"
                    },
                    children: [
                        TagImageComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(TagImageComponent, {
                            bgColor: config === null || config === void 0 ? void 0 : config.backgroundColor
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: classnames_default()("tw-absolute tw-left-[50%] tw-top-[50%] tw-z-[1] tw-m-0 tw-text-center tw-font-medium", !isMobile ? "tw-text-[12px]" : "tw-text-[10px]"),
                            style: {
                                color: config === null || config === void 0 ? void 0 : config.textColor,
                                transform: "translateX(-50%) translateY(calc(-50% - ".concat(translateOffset, "px))")
                            },
                            children: showPercentDiscount ? "".concat(discount, "% OFF") : "".concat(src_config/* CURRENCY_SYMBOL */.o + discount, " OFF")
                        })
                    ]
                });
            }
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                style: {
                    background: (config === null || config === void 0 ? void 0 : config.discountStyle) !== "text" && (config === null || config === void 0 ? void 0 : config.backgroundColor),
                    color: config === null || config === void 0 ? void 0 : config.textColor
                },
                className: classnames_default()("tw-m-0 tw-break-keep tw-text-center tw-text-[11px] tw-font-medium tw-leading-[1]", (config === null || config === void 0 ? void 0 : config.discountStyle) !== "text" ? "tw-px-[4px] tw-py-[2px] tw-leading-[1]" : "tw-leading-[0.94]"),
                children: showPercentDiscount ? "".concat(discount, "% OFF") : "".concat(src_config/* CURRENCY_SYMBOL */.o + discount, " OFF")
            });
    }
}

// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
;// CONCATENATED MODULE: ./src/utils/removeHTMLTagsFromString.ts

// function to remove all anchor tags from string
function removeHTMLTagsFromString(str) {
    if (checkRenderEnv/* IS_SERVER */.W6) {
        return str;
    }
    var tmp = document.createElement("div");
    // add string to created div as html
    tmp.innerHTML = str;
    // get all anchor tags added to created element
    var anchor_tag_collection = tmp.getElementsByTagName("a");
    // iterate over all the tags and remove them from the HTML collection
    if (anchor_tag_collection.length) {
        // convert HTML collection to array
        Array.from(anchor_tag_collection).forEach(function(tag) {
            // remove the tags
            if (tag) {
                tag.parentNode.removeChild(tag);
            }
        });
    }
    return tmp.textContent || tmp.innerText || "";
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/components/VariantsRenderer.tsx






function VariantsRenderer(param) {
    var productData = param.productData, config = param.config, isMobile = param.isMobile, overrideStyles = param.overrideStyles;
    var ref, ref1, ref2;
    var hasVariant = productData === null || productData === void 0 ? void 0 : (ref = productData.item_option_variants) === null || ref === void 0 ? void 0 : ref.length;
    var overrideTextColor = overrideStyles === null || overrideStyles === void 0 ? void 0 : overrideStyles.textColor;
    var variantsList = (0,react.useMemo)(function() {
        var ref, ref1;
        return hasVariant ? ((ref1 = productData === null || productData === void 0 ? void 0 : (ref = productData.item_option_variants) === null || ref === void 0 ? void 0 : ref.find(function(item) {
            return item[config === null || config === void 0 ? void 0 : config.variantType];
        })) === null || ref1 === void 0 ? void 0 : ref1[config === null || config === void 0 ? void 0 : config.variantType]) || [] : [];
    }, [
        productData === null || productData === void 0 ? void 0 : productData.item_option_variants,
        config === null || config === void 0 ? void 0 : config.variantType
    ]);
    if (!hasVariant || !(config === null || config === void 0 ? void 0 : config.showVariant)) {
        return null;
    }
    if (!(variantsList === null || variantsList === void 0 ? void 0 : variantsList.length)) {
        return null;
    }
    var isTextOnly = (config === null || config === void 0 ? void 0 : config.variantShape) === "text";
    var isCircle = config === null || config === void 0 ? void 0 : (ref1 = config.variantShape) === null || ref1 === void 0 ? void 0 : ref1.includes("circle");
    var isVariantTypeColor = [
        "colour",
        "color"
    ].includes(config === null || config === void 0 ? void 0 : (ref2 = config.variantType) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase());
    var variantTextStyles = (0,utils/* getVariantTextStyles */.fR)(config);
    var maxVariantsNum = isMobile ? 4 : 6;
    var choosenVariantList = variantsList.slice(0, maxVariantsNum);
    if (!(choosenVariantList === null || choosenVariantList === void 0 ? void 0 : choosenVariantList.length)) {
        return null;
    }
    var extraVariantSingularStyle = (0,utils/* getVariantSingularTextStyles */.O)(config, {
        isColorVariant: false,
        isTextOnly: isTextOnly,
        isOneCharacterName: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()("tw-flex tw-items-center", !isTextOnly || (config === null || config === void 0 ? void 0 : config.separateVariantWithComa) ? "tw-gap-x-[6px] tw-gap-y-[6px]" : "tw-gap-x-[3px] tw-gap-y-[3px]"),
        children: [
            choosenVariantList.map(function(variant, index, arr) {
                var ref;
                var isColorVariant = variant === null || variant === void 0 ? void 0 : variant.colour_code;
                var variantName = variant === null || variant === void 0 ? void 0 : variant.variant_name;
                var isOneCharacterName = (variant === null || variant === void 0 ? void 0 : (ref = variant.variant_name) === null || ref === void 0 ? void 0 : ref.length) === 1;
                var variantSingularStyle = (0,utils/* getVariantSingularTextStyles */.O)(config, {
                    isColorVariant: isVariantTypeColor,
                    isTextOnly: isTextOnly,
                    isOneCharacterName: isOneCharacterName
                });
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("tw-flex tw-items-center tw-justify-center tw-font-medium", isColorVariant && !isTextOnly && (!isMobile ? "tw-h-[8px] tw-w-[8px]" : "tw-h-[12px] tw-w-[12px]"), !isColorVariant && !isTextOnly && (isCircle ? "tw- tw-px-[6px] tw-py-[3.5px]" : "tw-px-[7px] tw-py-[4px]"), isCircle && "tw-rounded-[12px]", "tw-font-normal", overrideTextColor ? "tw-text-[".concat(overrideTextColor, "]") : "tw-text-newBlack/[0.9]"),
                    style: (0,_object_spread/* default */.Z)({
                        border: (!isTextOnly || overrideTextColor) && "0.5px solid",
                        borderColor: overrideTextColor ? (0,common/* hexToRgba */.a7)(overrideTextColor, 0.4) : "#111C3633",
                        background: (variant === null || variant === void 0 ? void 0 : variant.colour_code) || (overrideTextColor ? "transparent" : !isTextOnly ? "#ffffff" : "transparent")
                    }, variantTextStyles.style, variantSingularStyle.style),
                    children: [
                        !isColorVariant ? variantName : "",
                        isTextOnly && (config === null || config === void 0 ? void 0 : config.separateVariantWithComa) && index !== arr.length - 1 && ","
                    ]
                }, variant === null || variant === void 0 ? void 0 : variant.variant_name_id);
            }),
            (variantsList === null || variantsList === void 0 ? void 0 : variantsList.length) - (choosenVariantList === null || choosenVariantList === void 0 ? void 0 : choosenVariantList.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("tw-flex tw-items-center tw-justify-center tw-font-medium", !isTextOnly && (!isMobile ? "tw-h-[8px] tw-w-[11px]" : "tw-h-[12px] tw-w-[12px]"), !isTextOnly && (isCircle ? "tw-px-[11.5px] tw-py-[3.5px]" : "tw-px-[11px] tw-py-[4px]"), isCircle && "tw-rounded-[12px]", overrideTextColor ? "tw-text-[".concat(overrideTextColor, "]") : "tw-text-newBlack/[0.9]"),
                style: (0,_object_spread/* default */.Z)({
                    border: (!isTextOnly || overrideTextColor) && "0.5px solid",
                    borderColor: overrideTextColor ? (0,common/* hexToRgba */.a7)(overrideTextColor, 0.4) : "#111C3633",
                    background: overrideTextColor ? "transparent" : !isTextOnly ? "#ffffff" : "transparent"
                }, variantTextStyles.style, extraVariantSingularStyle.style),
                children: [
                    "+",
                    (variantsList === null || variantsList === void 0 ? void 0 : variantsList.length) - (choosenVariantList === null || choosenVariantList === void 0 ? void 0 : choosenVariantList.length)
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/utils/checkIfObjectExists.ts
var checkIfObjectExists = __webpack_require__(31891);
// EXTERNAL MODULE: ./src/utils/removeEmojis.ts
var removeEmojis = __webpack_require__(51389);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/components/Tags.tsx








function Tags(param) {
    var isMobile = param.isMobile, productData = param.productData, config = param.config;
    var ref = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref.widgetContextState, customTags = _widgetContextState.customTags, isBuilder = _widgetContextState.isBuilder;
    var productTagsList = (productData === null || productData === void 0 ? void 0 : productData.tags) || [];
    if (!productTagsList.length || !(config === null || config === void 0 ? void 0 : config.showTag)) return null;
    var getTagConfig = function(tag) {
        var doesCustomTagExists = (0,checkIfObjectExists/* checkIfObjectExists */.L)(tag.custom_config);
        var fallbackConfig = (config === null || config === void 0 ? void 0 : config.tagAppearance) !== "default" ? config || tag : tag;
        var tagConfigs = (config === null || config === void 0 ? void 0 : config.tagAppearance) === "default" ? tag : doesCustomTagExists ? tag.custom_config : fallbackConfig;
        if (isBuilder) {
            var globalCounterpart = customTags === null || customTags === void 0 ? void 0 : customTags.find(function(globalTag) {
                return (globalTag === null || globalTag === void 0 ? void 0 : globalTag.id) === (tag === null || tag === void 0 ? void 0 : tag.id);
            });
            var doesCustomTagExistsInGlobal = (0,checkIfObjectExists/* checkIfObjectExists */.L)(globalCounterpart === null || globalCounterpart === void 0 ? void 0 : globalCounterpart.custom_config);
            return (config === null || config === void 0 ? void 0 : config.tagAppearance) === "default" ? tagConfigs : doesCustomTagExistsInGlobal ? globalCounterpart === null || globalCounterpart === void 0 ? void 0 : globalCounterpart.custom_config : tagConfigs;
        }
        return tagConfigs;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-inline-flex tw-w-max tw-flex-col tw-flex-wrap tw-gap-[4px]",
        children: productTagsList.map(function(tag, idx) {
            var tagsTintConfigs = getTagConfig(tag);
            var tagsWrapperStyles = (0,utils/* getTagsWrapperStyles */.xv)(config, tagsTintConfigs);
            var tagName = (config === null || config === void 0 ? void 0 : config.tagAppearance) !== "default" ? (0,removeEmojis/* removeEmojisFromTagName */.U)(tag === null || tag === void 0 ? void 0 : tag.name) : tag === null || tag === void 0 ? void 0 : tag.name;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("tw-relative tw-w-max tw-px-[6px] tw-py-[4px] tw-text-[11px] tw-font-medium ", tagsWrapperStyles.className),
                style: (0,_object_spread/* default */.Z)({}, tagsWrapperStyles.style),
                children: [
                    tagsWrapperStyles.ChildComponent,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: tagName
                    })
                ]
            }, tag.id || idx);
        })
    });
}

// EXTERNAL MODULE: ./src/utils/formatPricing.ts
var formatPricing = __webpack_require__(54065);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/components/ElementPicker.tsx




















function BelowElementPicker(param) {
    var isMobile = param.isMobile, productData = param.productData, elementData = param.elementData, renderrerList = param.renderrerList, adjacentElements = param.adjacentElements, snackbarMethods = param.snackbarMethods, overrideStyles = param.overrideStyles;
    var ref, ref1;
    var reviewSettings = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.catalogReducer.reviewSettings;
    });
    var crrFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().crrFeatureStatus;
    var config = elementData.config;
    var variantComponentConfig = (ref = renderrerList.find(function(item) {
        return item.type === "variant";
    })) === null || ref === void 0 ? void 0 : ref.config;
    var hasChoosenVariant = !!(productData === null || productData === void 0 ? void 0 : (ref1 = productData.item_option_variants) === null || ref1 === void 0 ? void 0 : ref1.some(function(item) {
        return item[variantComponentConfig === null || variantComponentConfig === void 0 ? void 0 : variantComponentConfig.variantType];
    }));
    var showChoosenVariants = (variantComponentConfig === null || variantComponentConfig === void 0 ? void 0 : variantComponentConfig.showVariant) && hasChoosenVariant;
    var ratingConfigs;
    if (elementData.type === "rating" || (adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.next) === "rating") {
        var ref2, ref3;
        var ratingData = productData === null || productData === void 0 ? void 0 : productData.store_item_review_rating;
        var ratingComponentConfig = (ref2 = renderrerList.find(function(item) {
            return item.type === "rating";
        })) === null || ref2 === void 0 ? void 0 : ref2.config;
        // const checkShowForAvgRating =
        //   ratingComponentConfig?.minAvgRating &&
        //   ratingData?.review_rating?.[0]?.avg_rating >= 3.5;
        // const checkForAtleastMinNum =
        //   ratingComponentConfig?.minRating &&
        //   (ratingData?.review_rating?.[0]?.ratings_count || ratingData?.ratings_count) >= 3;
        var hasRating = (ratingComponentConfig === null || ratingComponentConfig === void 0 ? void 0 : ratingComponentConfig.showRatings) && !(crrFeatureStatus === null || crrFeatureStatus === void 0 ? void 0 : crrFeatureStatus.isLocked) && (reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.status) && (ratingData === null || ratingData === void 0 ? void 0 : ratingData.review_rating) && ((ref3 = ratingData === null || ratingData === void 0 ? void 0 : ratingData.review_rating[0]) === null || ref3 === void 0 ? void 0 : ref3.avg_rating);
        ratingConfigs = {
            hasRating: hasRating
        };
    }
    // Name & description are clubbed together
    switch(elementData.type){
        case "name":
            {
                var ref4, ref5;
                var productNameStyles = (0,utils/* getProductNameStyles */.HQ)(config);
                var descriptionComponent = renderrerList.find(function(item) {
                    return item.type === "description";
                });
                var marginSpacerClass = function() {
                    if (adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.isLastItem) return null;
                    switch(adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.next){
                        case "variant":
                            return showChoosenVariants ? "tw-mb-[12px]" : null;
                        case "rating":
                            return (ratingConfigs === null || ratingConfigs === void 0 ? void 0 : ratingConfigs.hasRating) ? "tw-mb-[12px]" : null;
                        case "price":
                            return "tw-mb-[10px]";
                        default:
                            return null;
                    }
                }();
                var productDescriptionStyles = (0,utils/* getProductDescriptionStyles */.MX)(descriptionComponent === null || descriptionComponent === void 0 ? void 0 : descriptionComponent.config, isMobile);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cardIntroWrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: classnames_default()("tw-m-0 tw-text-[16px]", (config === null || config === void 0 ? void 0 : config.productNameNumOfLine) !== "one" && "tw-leading-[1.4]", productNameStyles.className),
                                    style: (0,_object_spread/* default */.Z)({
                                        color: (overrideStyles === null || overrideStyles === void 0 ? void 0 : overrideStyles.textColor) || config.productNameColor
                                    }, productNameStyles.style),
                                    children: removeHTMLTagsFromString(productData === null || productData === void 0 ? void 0 : productData.name)
                                }),
                                (descriptionComponent === null || descriptionComponent === void 0 ? void 0 : (ref4 = descriptionComponent.config) === null || ref4 === void 0 ? void 0 : ref4.showDescription) && !!(productData === null || productData === void 0 ? void 0 : (ref5 = productData.description) === null || ref5 === void 0 ? void 0 : ref5.trim()) && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: classnames_default()("tw-m-0 tw-text-[12px] tw-font-normal", (config === null || config === void 0 ? void 0 : config[!isMobile ? "productdescriptionDesktopNumOfLines" : "productdescriptionMobileNumOfLines"]) !== "one" && "tw-leading-[1.4]", isMobile ? "tw-mt-[6px]" : "tw-mt-[8px]", productDescriptionStyles.className),
                                    style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        color: (0,common/* hexToRgba */.a7)(overrideStyles === null || overrideStyles === void 0 ? void 0 : overrideStyles.textColor, 0.6) || (descriptionComponent === null || descriptionComponent === void 0 ? void 0 : descriptionComponent.config.productDescriptionColor)
                                    }, productDescriptionStyles.style), {
                                        overflowWrap: "anywhere",
                                        hyphens: "auto"
                                    }),
                                    children: removeHTMLTagsFromString(productData === null || productData === void 0 ? void 0 : productData.description)
                                })
                            ]
                        }),
                        !!marginSpacerClass && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: marginSpacerClass
                        })
                    ]
                });
            }
        case "description":
            {
                var marginSpacerClass1 = function() {
                    if ((adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.above) !== "name" && (adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.above) !== "price" || (adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.isLastItem)) return null;
                    switch(adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.next){
                        case "price":
                            return "tw-mb-[10px]";
                        case "variant":
                            return showChoosenVariants ? "tw-mb-[12px]" : null;
                        case "rating":
                            return (ratingConfigs === null || ratingConfigs === void 0 ? void 0 : ratingConfigs.hasRating) ? "tw-mb-[12px]" : null;
                        default:
                            return null;
                    }
                }();
                return !!marginSpacerClass1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: marginSpacerClass1
                });
            }
        case "price":
            {
                var ref6, ref7;
                var discountComponent = renderrerList.find(function(item) {
                    return item.type === "discount";
                });
                var productPriceStyles = (0,utils/* getProductPriceStyles */.tk)(config);
                var productActualPriceStyles = (0,utils/* getProductActualPriceStyles */.D_)(productPriceStyles.style);
                var isB2bStore = (0,getStoreType/* getStoreType */.K)() === constants/* STORE_CUSTOMIZATION.B2B */.DO.B2B;
                var marginSpacerClass2 = function() {
                    if (adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.isLastItem) return null;
                    switch(adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.next){
                        case "button":
                            return null;
                        case "variant":
                            return showChoosenVariants ? "tw-mb-[12px]" : null;
                        case "rating":
                            return (ratingConfigs === null || ratingConfigs === void 0 ? void 0 : ratingConfigs.hasRating) ? "tw-mb-[12px]" : null;
                        case "name":
                            return "tw-mb-[10px]";
                        default:
                            return null;
                    }
                }();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("pricingSection tw-flex tw-flex-wrap tw-gap-x-[8px] tw-gap-y-[6px]", (discountComponent === null || discountComponent === void 0 ? void 0 : (ref6 = discountComponent.config) === null || ref6 === void 0 ? void 0 : ref6.discountStyle) === "text" ? "tw-items-end" : "tw-items-center"),
                            children: !isB2bStore ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "pricingSection tw-flex tw-flex-wrap tw-items-end tw-gap-x-[4px] tw-gap-y-[6px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: "tw-relative tw-bottom-[-0.5px] tw-m-0 tw-leading-[0.88] tw-text-newBlack",
                                                style: (0,_object_spread/* default */.Z)({
                                                    color: (overrideStyles === null || overrideStyles === void 0 ? void 0 : overrideStyles.textColor) || config.productPriceColor
                                                }, productPriceStyles.style),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: paymentLinks/* CURRENT_CURRENCY_SYMBOL */.bZ
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: (0,formatPricing/* formatPriceToINR */.e)(productData === null || productData === void 0 ? void 0 : productData.discounted_price)
                                                    })
                                                ]
                                            }),
                                            (productData === null || productData === void 0 ? void 0 : productData.discounted_price) !== (productData === null || productData === void 0 ? void 0 : productData.price) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                style: (0,_object_spread/* default */.Z)({
                                                    color: (0,common/* hexToRgba */.a7)((overrideStyles === null || overrideStyles === void 0 ? void 0 : overrideStyles.textColor) || config.productPriceColor, 0.6)
                                                }, productActualPriceStyles.style),
                                                className: "tw-m-0 tw-text-[13px] tw-leading-[0.88] tw-text-newBlack/[0.6] tw-line-through",
                                                children: [
                                                    paymentLinks/* CURRENT_CURRENCY_SYMBOL */.bZ,
                                                    (0,formatPricing/* formatPriceToINR */.e)(productData === null || productData === void 0 ? void 0 : productData.price)
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountTag, {
                                        productData: productData,
                                        config: discountComponent === null || discountComponent === void 0 ? void 0 : discountComponent.config,
                                        isMobile: isMobile
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "tw-m-0 tw-text-[14px] tw-leading-[1] tw-text-newBlack",
                                style: (0,_object_spread/* default */.Z)({
                                    color: (overrideStyles === null || overrideStyles === void 0 ? void 0 : overrideStyles.textColor) || config.productPriceColor
                                }, productPriceStyles.style),
                                children: (productData === null || productData === void 0 ? void 0 : (ref7 = productData.b2b_pricing_info) === null || ref7 === void 0 ? void 0 : ref7.price_range) || "Price on Request"
                            })
                        }),
                        !!marginSpacerClass2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: marginSpacerClass2
                        })
                    ]
                });
            }
        case "button":
            return (config === null || config === void 0 ? void 0 : config.showAddToCart) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tw-mt-auto"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: isMobile ? "tw-mt-[16px]" : "tw-mt-[20px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButton, {
                        isMobile: isMobile,
                        productData: productData,
                        config: config,
                        snackbarMethods: snackbarMethods,
                        overrideStyles: overrideStyles
                    })
                ]
            }) : null;
        case "variant":
            {
                var marginSpacerClass3 = function() {
                    if (adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.isLastItem) return null;
                    switch(adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.next){
                        case "price":
                        case "name":
                            return "tw-mb-[12px]";
                        case "rating":
                            return (ratingConfigs === null || ratingConfigs === void 0 ? void 0 : ratingConfigs.hasRating) ? "tw-mb-[12px]" : null;
                        default:
                            return null;
                    }
                }();
                return showChoosenVariants ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantsRenderer, {
                            productData: productData,
                            config: config,
                            overrideStyles: overrideStyles,
                            isMobile: isMobile
                        }),
                        !!marginSpacerClass3 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: marginSpacerClass3
                        })
                    ]
                }) : null;
            }
        case "rating":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingComponent, {
                productData: productData,
                type: 2,
                overrideStyles: overrideStyles,
                config: config,
                insertMarginBottom: !(adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.isLastItem) ? (adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.next) === "variant" && showChoosenVariants || (adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.next) === "price" || (adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.next) === "name" || (adjacentElements === null || adjacentElements === void 0 ? void 0 : adjacentElements.next) === "rating" && (ratingConfigs === null || ratingConfigs === void 0 ? void 0 : ratingConfigs.hasRating) : false
            });
        default:
            return null;
    }
}
function OverlayElementPicker(param) {
    var isMobile = param.isMobile, productData = param.productData, elementData = param.elementData, snackbarMethods = param.snackbarMethods;
    var config = elementData.config;
    switch(elementData.type){
        case "rating":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayItemsAligner, {
                    coordinates: config.coordinates,
                    isMobile: isMobile,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RatingComponent, {
                        productData: productData,
                        type: 1,
                        config: config
                    })
                });
            }
        case "discount":
            {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayItemsAligner, {
                    coordinates: config.coordinates,
                    config: config,
                    isMobile: isMobile,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountTag, {
                        productData: productData,
                        config: config,
                        isMobile: isMobile
                    })
                });
            }
        case "button":
            return (config === null || config === void 0 ? void 0 : config.showAddToCart) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayItemsAligner, {
                coordinates: config.coordinates,
                isMobile: isMobile,
                customStyles: {
                    width: (config === null || config === void 0 ? void 0 : config.buttonType) === "icon" ? "max-content" : "calc(100% - ".concat(isMobile ? 16 : 20, "px)")
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartButton, {
                    isMobile: isMobile,
                    productData: productData,
                    config: config,
                    isOverlay: true,
                    snackbarMethods: snackbarMethods
                })
            }) : null;
        case "tags":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(OverlayItemsAligner, {
                coordinates: config.coordinates,
                isMobile: isMobile,
                customClass: "tw-flex tw-flex-wrap",
                customStyles: {
                    width: "max-content"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags, {
                    isMobile: isMobile,
                    productData: productData,
                    config: config
                })
            });
        default:
            return null;
    }
}

// EXTERNAL MODULE: ./src/utils/scrollItemAndRemoveDetails.js
var scrollItemAndRemoveDetails = __webpack_require__(4286);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/components/OutOfStockStrip.tsx



function OutOfStockStrip(param) {
    var isMobile = param.isMobile, isVisible = param.isVisible, isFullWidthCard = param.isFullWidthCard;
    if (!isVisible) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(isMobile ? "tw-h-[40px]" : "tw-h-[44px]", "tw-absolute tw-bottom-0 tw-left-0 tw-z-[5] tw-flex tw-w-full tw-items-center tw-justify-center tw-bg-[#ffffff]/[0.9] tw-text-[13px] tw-font-medium tw-text-[#445378]", isFullWidthCard && "removeGlobalOverride imgWrapperGlobalStyle globalImgStyleConsumer addTopLeftGlobalRadius addTopRightGlobalRadius"),
        children: "Currently unavailable"
    });
}

// EXTERNAL MODULE: ./src/hooks/useItemClick.js + 1 modules
var useItemClick = __webpack_require__(80058);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/ProductCard.tsx



















function ProductCard(_param) {
    var productData = _param.productData, itemIndex = _param.itemIndex, onItemClickFromProp = _param.onItemClick, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "productData",
        "itemIndex",
        "onItemClick"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    var cardRef = (0,react.useRef)(null);
    var ref17 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref17.widgetContextState.globalStyle;
    var infoList = globalStyle.productCard.infoList;
    var cartData = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.cartReducer;
    });
    var itemIndexInCart = (0,itemIndexFromCart/* itemIndexFromCart */.R)(cartData, productData);
    var isItemInCart = itemIndexInCart >= 0;
    // This acts as a fallback
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useItemClick/* useItemClick */.M)(), 1), onItemClick = ref18[0];
    var isMobile = restProps === null || restProps === void 0 ? void 0 : (ref = restProps.configs) === null || ref === void 0 ? void 0 : ref.isMobile;
    var ref19 = (0,react.useState)(0), setDiscountPercent = ref19[1];
    var buttonElement = infoList === null || infoList === void 0 ? void 0 : infoList.find(function(item) {
        return item.type === "button";
    });
    var layoutElement = infoList === null || infoList === void 0 ? void 0 : infoList.find(function(item) {
        return item.type === "layout";
    });
    var isButtonBelowImage = (buttonElement === null || buttonElement === void 0 ? void 0 : buttonElement.elementPosition) === "below" && (buttonElement === null || buttonElement === void 0 ? void 0 : (ref1 = buttonElement.config) === null || ref1 === void 0 ? void 0 : ref1.showAddToCart) && (buttonElement === null || buttonElement === void 0 ? void 0 : (ref2 = buttonElement.config) === null || ref2 === void 0 ? void 0 : ref2.buttonConfig.find(function(item) {
        return item.isShow;
    }));
    var cardWrapperConfigs = (restProps === null || restProps === void 0 ? void 0 : (ref3 = restProps.configs) === null || ref3 === void 0 ? void 0 : ref3.cardWrapperConfigs) || (0,utils/* getCartWrapperConfigs */.Ui)(layoutElement === null || layoutElement === void 0 ? void 0 : layoutElement.config);
    var isFullWidthImgInCard = cardWrapperConfigs.isCardLayout && cardWrapperConfigs.isFullWidth;
    var uiComponents = infoList.reduce(function(acc, current) {
        if (current.elementPosition === "below") {
            if (current.config.buttonType !== "iconFrontOfProductName") {
                acc.belowElements.columnOne.push(current);
            } else {
                acc.belowElements.columnTwo.push(current);
            }
        }
        if (current.elementPosition === "overlay") {
            acc.overlayElements.push(current);
        }
        if (current.type === "image") {
            acc.imageElement = current;
        }
        return acc;
    }, {
        belowElements: {
            columnOne: [],
            columnTwo: []
        },
        overlayElements: [],
        imageElement: {}
    });
    (0,react.useEffect)(function() {
        if (productData && (productData === null || productData === void 0 ? void 0 : productData.is_active) !== constants/* ITEM_ACTIVE_STATUS.HIDDEN */.p4.HIDDEN) {
            var percent = (0,getDiscountPercentage/* getDiscountPercentage */.$)(productData === null || productData === void 0 ? void 0 : productData.price, productData === null || productData === void 0 ? void 0 : productData.discounted_price);
            setDiscountPercent(percent ? percent : 0);
            (0,scrollItemAndRemoveDetails/* scrollItemAndRemoveDetails */.f)(productData, cardRef);
        }
    }, [
        productData
    ]);
    var productDetailsWrapper = (0,utils/* getProductDetailsWrapperStyles */["in"])(layoutElement === null || layoutElement === void 0 ? void 0 : layoutElement.config);
    var imagesToShow = productData === null || productData === void 0 ? void 0 : productData.images;
    var shapeStyleCalculated = (0,CardFrameCollection_utils/* getShapeStyles */.cw)(uiComponents === null || uiComponents === void 0 ? void 0 : (ref4 = uiComponents.imageElement) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.config) === null || ref5 === void 0 ? void 0 : ref5.imageShape, restProps === null || restProps === void 0 ? void 0 : (ref6 = restProps.configs) === null || ref6 === void 0 ? void 0 : ref6.dimensions.cardWidth, isFullWidthImgInCard);
    var shapeStyle = shapeStyleCalculated[itemIndex % (shapeStyleCalculated === null || shapeStyleCalculated === void 0 ? void 0 : shapeStyleCalculated.length)];
    // To add a class that removes global styling
    var removeGlobalStyle = isFullWidthImgInCard && !CardFrameCollection_utils/* IMAGE_SHAPE_OVERRIDING_GLOBAL_STYLE.includes */.HR.includes((ref7 = uiComponents.imageElement) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.config) === null || ref8 === void 0 ? void 0 : ref8.imageShape) ? "removeGlobalOverride imgWrapperGlobalStyle globalImgStyleConsumer addTopLeftGlobalRadius addTopRightGlobalRadius" : "";
    var addWrapperGlobalStyle = (0,utils/* getWrapperStylesBasedOnGlobal */.gt)(cardWrapperConfigs, globalStyle).addWrapperGlobalStyle;
    var isButtonInOverlay = uiComponents.overlayElements.find(function(element) {
        return element.type === "button";
    });
    var ctaHoverAnimationClass = (0,utils/* getCTAHoverAnimationClass */.X7)({
        buttonElement: buttonElement,
        isItemInCart: isItemInCart,
        isMobile: isMobile
    });
    var discountElementConfig = (ref9 = uiComponents.overlayElements.find(function(element) {
        return element.type === "discount";
    })) === null || ref9 === void 0 ? void 0 : ref9.config;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        onClick: function(e) {
            var ref;
            return (ref = onItemClickFromProp || onItemClick) === null || ref === void 0 ? void 0 : ref(productData, e);
        },
        ref: cardRef,
        className: classnames_default()("tw-flex tw-h-full tw-w-[100%] tw-cursor-pointer tw-flex-col", cardWrapperConfigs.isCardLayout ? classnames_default()(!cardWrapperConfigs.isFullWidth && (isMobile ? "tw-px-[10px] tw-py-[10px]" : "tw-px-[14px] tw-py-[14px]")) : "", cardWrapperConfigs.className, addWrapperGlobalStyle.className, restProps.configs.customWrapperClass, // For overlay based scenario
        ctaHoverAnimationClass),
        style: (0,_object_spread/* default */.Z)({}, cardWrapperConfigs.style, addWrapperGlobalStyle.style),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: (0,_object_spread/* default */.Z)({
                    height: "".concat(typeof (restProps === null || restProps === void 0 ? void 0 : (ref10 = restProps.configs) === null || ref10 === void 0 ? void 0 : ref10.dimensions.cardHeight) === "number" ? "".concat(restProps === null || restProps === void 0 ? void 0 : (ref11 = restProps.configs) === null || ref11 === void 0 ? void 0 : ref11.dimensions.cardHeight, "px") : (restProps === null || restProps === void 0 ? void 0 : (ref12 = restProps.configs) === null || ref12 === void 0 ? void 0 : ref12.dimensions.cardHeight) || "unset"),
                    // Removing border widths horizontally
                    width: "".concat(typeof (restProps === null || restProps === void 0 ? void 0 : (ref13 = restProps.configs) === null || ref13 === void 0 ? void 0 : ref13.dimensions.cardWidth) === "number" ? "".concat((restProps === null || restProps === void 0 ? void 0 : (ref14 = restProps.configs) === null || ref14 === void 0 ? void 0 : ref14.dimensions.cardWidth) - (cardWrapperConfigs.isFullWidth ? 2 : 0), "px") : (restProps === null || restProps === void 0 ? void 0 : (ref15 = restProps.configs) === null || ref15 === void 0 ? void 0 : ref15.dimensions.cardWidth) || "unset")
                }, shapeStyle === null || shapeStyle === void 0 ? void 0 : shapeStyle.style),
                className: classnames_default()("tw-relative tw-overflow-hidden", shapeStyle === null || shapeStyle === void 0 ? void 0 : shapeStyle.className),
                children: [
                    !(0,lodash.isEmpty)(uiComponents.imageElement) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageRenderer, {
                        images: imagesToShow,
                        config: (ref16 = uiComponents.imageElement) === null || ref16 === void 0 ? void 0 : ref16.config,
                        removeGlobalStyle: removeGlobalStyle,
                        isButtonInOverlay: isButtonInOverlay,
                        productData: productData
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("overlayWrapper tw-pointer-events-none tw-absolute tw-inset-0", isMobile ? "tw-p-[8px]" : "tw-p-[10px]", removeGlobalStyle || "imgWrapperGlobalStyle " + ((discountElementConfig === null || discountElementConfig === void 0 ? void 0 : discountElementConfig.discountTag) === utils/* DISCOUNT_IMAGE_TAG.SQUARE */.WL.SQUARE ? " tw-overflow-hidden" : "")),
                        children: [
                            uiComponents.overlayElements.map(function(item, index) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(OverlayElementPicker, {
                                    elementData: item,
                                    productData: productData,
                                    isMobile: isMobile,
                                    snackbarMethods: restProps === null || restProps === void 0 ? void 0 : (ref = restProps.configs) === null || ref === void 0 ? void 0 : ref.snackbarMethods
                                }, index);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OutOfStockStrip, {
                                isMobile: isMobile,
                                isVisible: !(productData === null || productData === void 0 ? void 0 : productData.available),
                                isFullWidthCard: cardWrapperConfigs.isFullWidth
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("cardAllInfoWrapper tw-flex tw-flex-grow tw-flex-row tw-gap-[16px]", cardWrapperConfigs.isFullWidth && (isMobile ? "tw-px-[10px] ".concat(!isButtonBelowImage ? "tw-pb-[16px]" : "tw-pb-[10px]") : "tw-px-[12px] ".concat(!isButtonBelowImage ? "tw-pb-[20px]" : "tw-pb-[10px]")), !isMobile ? "tw-mt-[16px]" : "tw-mt-[12px]"),
                children: Object.values(uiComponents.belowElements).map(function(column, index) {
                    var isFirstColumn = !index;
                    if (!column.length) {
                        return null;
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("cardDetailsWrapper tw-flex tw-flex-grow tw-flex-col", isFirstColumn && "tw-flex-grow", productDetailsWrapper.className),
                        children: column.map(function(item, index, array) {
                            var ref, ref1, ref2, ref3, ref4;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(BelowElementPicker, {
                                elementData: item,
                                renderrerList: array,
                                productData: productData,
                                isMobile: isMobile,
                                adjacentElements: {
                                    next: (ref = column[index + 1]) === null || ref === void 0 ? void 0 : ref.type,
                                    above: (ref1 = column[index - 1]) === null || ref1 === void 0 ? void 0 : ref1.type,
                                    // Treat the all of the remaining elements as to not put spacing if they are directly above the CTA
                                    isLastItem: ((ref2 = column[index + 1]) === null || ref2 === void 0 ? void 0 : ref2.type) === "button",
                                    isFirstItem: ((ref3 = column[index + 1]) === null || ref3 === void 0 ? void 0 : ref3.type) === undefined
                                },
                                overrideStyles: restProps.configs.overrideStyles,
                                snackbarMethods: restProps === null || restProps === void 0 ? void 0 : (ref4 = restProps.configs) === null || ref4 === void 0 ? void 0 : ref4.snackbarMethods
                            }, index);
                        })
                    }, index);
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/index.ts



/***/ }),

/***/ 88583:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ ProductRating; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _mui_material_Rating__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60437);
/* harmony import */ var _mui_material_Rating__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2409);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50066);



var ProductRating = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(_mui_material_Rating__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    displayName: "ProductRating",
    componentId: "sc-2332941-0"
})(function(props) {
    var _obj;
    return _obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "&.".concat(_mui_material_Rating__WEBPACK_IMPORTED_MODULE_3__/* ["default"].root */ .Z.root), {
        fontSize: props.fontSize || "16px",
        lineHeight: 1,
        height: props.fontSize || "16px"
    }), //   [`& .${ratingClasses.iconFilled}`]: {
    //     color: '#ff6d75',
    //   },
    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, "& .".concat(_mui_material_Rating__WEBPACK_IMPORTED_MODULE_3__/* ["default"].iconEmpty */ .Z.iconEmpty), {
        color: props.emptyIconColor || "#171C2A33"
    }), _obj;
});


/***/ }),

/***/ 54065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ formatPriceToINR; }
/* harmony export */ });
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6337);

var formatPriceToINR = function(price) {
    var ref;
    if (!price) return price;
    if (_checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__/* .IS_SERVER */ .W6) return price;
    return ((ref = price.toLocaleString) === null || ref === void 0 ? void 0 : ref.call(price, "en-IN")) || price;
};


/***/ }),

/***/ 51389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ removeEmojisFromTagName; }
/* harmony export */ });
function removeEmojisFromTagName() {
    var stringer = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    var emojiRegex1 = RegExp("\\p{Emoji}", "u");
    var emojiRegex2 = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
    var tagClean1 = stringer === null || stringer === void 0 ? void 0 : stringer.replace(emojiRegex2, "");
    var isEmoji = emojiRegex1.test(tagClean1 === null || tagClean1 === void 0 ? void 0 : tagClean1[0]);
    return isEmoji ? (ref = tagClean1 === null || tagClean1 === void 0 ? void 0 : tagClean1.substring(1)) === null || ref === void 0 ? void 0 : ref.trim() : tagClean1 === null || tagClean1 === void 0 ? void 0 : tagClean1.trim();
}


/***/ }),

/***/ 4286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ scrollItemAndRemoveDetails; }
/* harmony export */ });
/* unused harmony export getItemClickedId */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13886);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6337);


/**
 *
 * @returns id of the product stored in session when user clicked it on PLP
 */ function getItemClickedId() {
    if (!_checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__/* .IS_SERVER */ .W6) {
        var ref;
        return (ref = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .ITEM_CLICKED_DATA */ .rB))) === null || ref === void 0 ? void 0 : ref.itemId;
    }
    return null;
}
/**
 * Scrolls the card into view if the data is saved in session storage, then removes the data from session storage.
 * @param {*} data
 * @param {*} cardRef
 */ function scrollItemAndRemoveDetails(data, cardRef) {
    if ((data === null || data === void 0 ? void 0 : data.id) === getItemClickedId()) {
        // cardRef?.current?.scrollIntoView({ behavior: 'auto', block: 'center' });
        setTimeout(function() {
            if (!_checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__/* .IS_SERVER */ .W6) {
                var sessionData = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .ITEM_CLICKED_DATA */ .rB));
                if (sessionData === null || sessionData === void 0 ? void 0 : sessionData.hasOwnProperty("itemId")) {
                    delete sessionData["itemId"];
                }
                sessionStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_0__/* .ITEM_CLICKED_DATA */ .rB, JSON.stringify(sessionData));
            }
        }, _constants__WEBPACK_IMPORTED_MODULE_0__/* .REMOVE_ITEM_DETAIL_TIMEPERIOD */ .OI);
    }
}


/***/ }),

/***/ 36508:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"widgetContentFadeInWrapper":"ContentButtonAnimationStyle_widgetContentFadeInWrapper__gzPMJ","fadeIn":"ContentButtonAnimationStyle_fadeIn__Mx5Ue","widgetContentFadeInZoomInWrapper":"ContentButtonAnimationStyle_widgetContentFadeInZoomInWrapper__9exDB","fadeInZoomIn":"ContentButtonAnimationStyle_fadeInZoomIn__FGJ6r","widgetContentMoveDownWrapper":"ContentButtonAnimationStyle_widgetContentMoveDownWrapper__EWZJt","moveDown":"ContentButtonAnimationStyle_moveDown__HotCW","builderSelectorDemo":"ContentButtonAnimationStyle_builderSelectorDemo__P7Dit","demoMoveDown":"ContentButtonAnimationStyle_demoMoveDown__VsgIP","widgetContentMoveUpWrapper":"ContentButtonAnimationStyle_widgetContentMoveUpWrapper__q4jnq","moveUp":"ContentButtonAnimationStyle_moveUp__JqBuF","demoMoveUp":"ContentButtonAnimationStyle_demoMoveUp__f_z3_","widgetContentSlideLeftWrapper":"ContentButtonAnimationStyle_widgetContentSlideLeftWrapper__C_WGJ","moveLeft":"ContentButtonAnimationStyle_moveLeft__wtumW","demoMoveLeft":"ContentButtonAnimationStyle_demoMoveLeft__XAysw","widgetContentSlideRightWrapper":"ContentButtonAnimationStyle_widgetContentSlideRightWrapper__Ael_0","moveRight":"ContentButtonAnimationStyle_moveRight__NWc9p","demoMoveRight":"ContentButtonAnimationStyle_demoMoveRight__kmTdf","imageZoomIn":"ContentButtonAnimationStyle_imageZoomIn__zXH0u","imageZoomOut":"ContentButtonAnimationStyle_imageZoomOut__ywFAu","zoomInOnHover":"ContentButtonAnimationStyle_zoomInOnHover__wpSXv","ambient":"ContentButtonAnimationStyle_ambient__lq2Vz","animationAmbient":"ContentButtonAnimationStyle_animationAmbient__Mp7Dt"};

/***/ }),

/***/ 46482:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel-primary":"styles_carousel-primary__zpTCe","carousel-secondary":"styles_carousel-secondary__WBsMB","scroll-horizontal":"styles_scroll-horizontal__zCjJF","scroll-container":"styles_scroll-container__h7_yh"};

/***/ })

}]);